var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLargeBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 532,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-310.879 338.5c6.269 18.312 14.018 35.988 23.159 52.821 27.697 73.036 87.614 132.723 154.746 162.221 34.094 15.007 75.386 17.747 105.741-8.278 14.24-12.205 21.466-29.054 28.459-46.685 6.82-17.277 14.973-32.531 29.022-44.112 29.754-24.543 68.633-28.381 104.709-28.552 39.363-.202 79.81 3.054 117.76-10.657 32.133-11.624 60.415-34.198 72.689-69.405 11.965-34.359 6.09-73.434-5.413-106.983-6.309-18.461-17.565-36.359-20.826-55.726-3.141-18.759 7.716-34.136 18.286-47.481 11.197-14.173 22.204-28.064 30.259-44.668 24.112-49.777 25.841-108.795 4.69-160.142-13.984-33.435-38.086-60.973-65.998-81.314-63.828-46.618-143.338-50.555-217.046-36.655-80.927 15.27-158.484 46.963-223.7 101.808-31.374 26.539-60.123 56.536-85.784 89.51-24.546 31.348-47.175 65.038-63.364 102.409-31.565 72.857-33.188 156.644-7.389 231.889z",
    fill: "#229490"
  })));
}

export default SvgLargeBlob;